import * as React from "react";

interface IProps {
  color: string;
}

const PlacedGCPIcon: React.FC<IProps> = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2601_1411)">
        <path
          opacity="0.8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.77593 2.29184C8.57648 2.10227 8.32716 2.00249 8.06788 2.00249C7.81856 2.00249 7.55928 2.10227 7.3698 2.29184L3.0417 6.6221C2.65277 7.01122 2.65277 7.63981 3.0417 8.02893L7.01078 12L3.0417 15.9711L1.98077 14.9107L4.88999 12L1.98077 9.08933C1.00641 8.11448 1.00641 6.53655 1.98077 5.5617L6.30887 1.23145C6.78995 0.750131 7.43538 0.502494 8.06788 0.502494C8.72474 0.502494 9.34059 0.759079 9.80932 1.2046L9.82326 1.21785L12.745 4.14106L15.6532 1.23145C16.628 0.256184 18.2064 0.256184 19.1812 1.23145L23.5093 5.5617C24.4836 6.53655 24.4836 8.11448 23.5093 9.08933L20.6014 11.9987L23.5192 14.9107C24.4936 15.8855 24.4936 17.4634 23.5192 18.4383L19.1775 22.7822L19.1636 22.7954C18.6949 23.2409 18.079 23.4975 17.4222 23.4975C16.7996 23.4975 16.1576 23.2732 15.6532 22.7686L12.745 19.8589L9.83685 22.7686C8.86208 23.7438 7.28365 23.7438 6.30887 22.7686L1.98077 18.4383L3.0417 17.3779L7.3698 21.7082C7.75873 22.0973 8.387 22.0973 8.77593 21.7082L12.745 17.7371L16.7141 21.7082C16.9136 21.9077 17.1629 21.9975 17.4222 21.9975C17.6814 21.9975 17.9308 21.8977 18.1302 21.7082L22.4583 17.3779C22.8472 16.9888 22.8472 16.3602 22.4583 15.9711L18.4796 12.0003L22.4483 8.02893C22.8373 7.63981 22.8373 7.01122 22.4483 6.6221L18.1202 2.29184C17.7313 1.90272 17.103 1.90272 16.7141 2.29184L12.745 6.26291L8.77593 2.29184ZM3.0417 17.3779C2.65277 16.9888 2.65277 16.3602 3.0417 15.9711L1.98077 14.9107C1.00641 15.8855 1.00641 17.4634 1.98077 18.4383L3.0417 17.3779Z"
          fill="white"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M18.4792 12L22.4483 8.02893C22.8373 7.63981 22.8373 7.01122 22.4483 6.6221L18.1202 2.29184C17.7313 1.90272 17.103 1.90272 16.7141 2.29184L12.745 6.26291L8.77593 2.29184C8.57648 2.10227 8.32716 2.00249 8.06788 2.00249C7.81856 2.00249 7.55928 2.10227 7.3698 2.29184L3.0417 6.6221C2.65277 7.01122 2.65277 7.63981 3.0417 8.02893L7.01078 12L3.0417 15.9711C2.65277 16.3602 2.65277 16.9888 3.0417 17.3779L7.3698 21.7082C7.75873 22.0973 8.387 22.0973 8.77593 21.7082L12.745 17.7371L16.7141 21.7082C16.9136 21.9077 17.1629 21.9975 17.4222 21.9975C17.6814 21.9975 17.9308 21.8977 18.1302 21.7082L22.4583 17.3779C22.8472 16.9888 22.8472 16.3602 22.4583 15.9711L18.4792 12ZM13.2858 7.46967C13.1452 7.32902 12.9544 7.25 12.7555 7.25C12.5566 7.25 12.3658 7.32902 12.2252 7.46967L8.21967 11.4752C8.07889 11.616 7.99986 11.8069 8 12.006C8.00014 12.2051 8.07943 12.396 8.2204 12.5366L12.2259 16.5311C12.5192 16.8236 12.9941 16.8229 13.2866 16.5296L17.2811 12.5241C17.5733 12.2311 17.5729 11.7568 17.2803 11.4642L13.2858 7.46967Z"
          fill="black"
        />
        <path
          opacity="0.8"
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12.7555 7.25C12.9544 7.25 13.1452 7.32902 13.2858 7.46967L17.2803 11.4642C17.5729 11.7568 17.5733 12.2311 17.2811 12.5241L13.2866 16.5296C12.9941 16.8229 12.5192 16.8236 12.2259 16.5311L8.2204 12.5366C8.07943 12.396 8.00014 12.2051 8 12.006C7.99986 11.8069 8.07889 11.616 8.21967 11.4752L12.2252 7.46967C12.3658 7.32902 12.5566 7.25 12.7555 7.25ZM12.7555 9.06066L9.81139 12.0048L12.7541 14.9393L15.6901 11.9952L12.7555 9.06066Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_2601_1411">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.75)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default React.memo(PlacedGCPIcon);
